<template>
  <div class="target">
<!--    <div class="box">-->
<!--      <div style="height: 0.1667rem">-->
<!--        <img src="@/assets/assetsNewImg/index/consultation.png" alt="">-->
<!--      </div>-->
<!--      <div class="title">-->
<!--        线上咨询-->
<!--      </div>-->
<!--    </div>-->

    <div class="box touch" @click="contact">
      <div>
        <img src="@/assets/assetsNewImg/index/contact.png" alt="">
      </div>
      <div class="title">
        联系我们
      </div>
    </div>

    <div class="box touch" @click="changeRoute">
      <div>
        <img src="@/assets/assetsNewImg/index/data-center.png" alt="">
      </div>
      <div class="title">
        资料中心
      </div>
    </div>

    <div class="top-box" @click="toTop">
      <div>
        <img src="@/assets/assetsNewImg/index/top.png" alt="">
      </div>
      <div class="top-title">
        返回顶部
      </div>
    </div>
  </div>
</template>

<script>
import {top, bottom} from "@/utils/common";

export default {
  name: "sideOptions",
  mounted() {
  },
  methods: {
    toTop() {
      top();
    },
    contact() {
      bottom();
    },
    changeRoute() {
      console.log(this.$route.path);
      if (this.$route.path === "/lab") {
        this.$emit("setToPaper");
      } else {
        this.$router.push({ path: "/lab",query: {id: 2}});
      }
    }
  }
};

</script>

<style scoped lang="less">
.touch {
  cursor: pointer;
}
.target {
  position: fixed;
  z-index: 999;
  right: 0;
  top: 500px;
  width: 105px;
  //height: 365px;
  background: #FFF;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
  text-align: center;
  .box {
    padding-top: 15px;
    padding-bottom: 15px;
    border-top: 1px solid #DDD;
    &:first-child {
      border-top: none;
    }
    .title {
      color: #000;
      font-family: OPPOSans;
      font-size: 14px;
      font-weight: 400;
    }

  }

  .top-box {
    cursor: pointer;
    width: 105px;
    padding-top: 20px;
    background: var(--blue, #224895);
    padding-bottom: 20px;

    .top-title {
      color: #FFF;
      font-family: OPPOSans;
      font-size: 14px;
      font-weight: 400;
    }
  }
}

</style>
